import { apiFetcher } from "../api-fetcher";

interface Request {
  productSource: 'BUNJANG'| 'MERCARI'; // default: BUNJANG
  productLimit?: number;
  categoryId?:number;
}


interface Response {
    keywordsList?: [];
    productsList?: { id: number; lastMod:string }[];
  }
export const getSeoSitemap = (params: Request) =>
  apiFetcher.get<Response>('/api/misc/v2/seo/sitemap', params);
